module.exports = __webpack_public_path__ + "media/images/icons/burger-42f52717e18a3a9a47078be8e7deb5df.svg";